import React from 'react';

const Home = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className='author'>
                            <h1 className='white'>This Application is created by Farman Gour</h1>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Home;